import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">平台特色</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">为什么选择91吃瓜爆料</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[900px] mx-auto">
          {featuresData.map((feature) => (
            <div key={feature.id} className="flex flex-col items-center text-center p-5 md:p-6 rounded-lg bg-background-50 border border-background-200">
              <div className="w-14 h-14 rounded-full bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}